import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectAlert } from "stores/alert/selectors.alert";
import { resetAlert } from "stores/alert/slice.alert";

const AlertProvider = ({ children }) => {
  const dispatch = useDispatch();
  const alert = useSelector(selectAlert);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (alert?.message) {
      setVisible(true);
      const t = setTimeout(() => {
        setVisible(false);
        setTimeout(() => dispatch(resetAlert()), 300);
      }, 3000);
      return () => clearTimeout(t);
    }
  }, [alert?.message, alert?.type]);

  const isError = alert?.type === 'error';

  return (
    <div>
      {children}

      {/* ── TOAST — dark pill style ── */}
      <div style={{
        position: 'fixed',
        bottom: 32,
        left: '50%',
        transform: `translateX(-50%) translateY(${visible ? '0' : '16px'})`,
        opacity: visible ? 1 : 0,
        transition: 'opacity 0.22s ease, transform 0.22s ease',
        zIndex: 9999,
        pointerEvents: 'none',
      }}>
        {alert?.message && (
          <div style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: 10,
            padding: '11px 22px',
            borderRadius: 999,
            background: '#111827',
            color: '#fff',
            fontSize: 13,
            fontWeight: 600,
            fontFamily: "'Be Vietnam Pro', -apple-system, sans-serif",
            boxShadow: '0 8px 32px rgba(17,24,39,0.28)',
            whiteSpace: 'nowrap',
          }}>
            {/* Icon */}
            {isError ? (
              <svg width="15" height="15" viewBox="0 0 15 15" fill="none">
                <circle cx="7.5" cy="7.5" r="6.5" stroke="#EF4444" strokeWidth="1.8"/>
                <path d="M5 5l5 5M10 5l-5 5" stroke="#EF4444" strokeWidth="1.8" strokeLinecap="round"/>
              </svg>
            ) : (
              <svg width="15" height="15" viewBox="0 0 15 15" fill="none">
                <path d="M2.5 8l3.5 3.5 6.5-7" stroke="#22C55E" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            )}
            {alert.message}
          </div>
        )}
      </div>
    </div>
  );
};

export default AlertProvider;
